import { useState, useEffect } from "react"
import Cookies from "js-cookie"
import ReactGA from "react-ga"
import { Link } from "react-router-dom"
import "./CookiesConsent.css"

const trackingID = "G-28ML9E748R" // Tvůj GA Tracking ID

const CookiesConsent = () => {
  const [cookieAccepted, setCookieAccepted] = useState(false)
  const [showBanner, setShowBanner] = useState(true)

  useEffect(() => {
    const accepted = Cookies.get("cookieConsent")

    if (accepted) {
      setCookieAccepted(true)

      // Inicializuj Google Analytics
      ReactGA.initialize(trackingID)
      ReactGA.set({ page: window.location.pathname })
      ReactGA.pageview(window.location.pathname)
      setShowBanner(false)

    }
  }, [])

  const handleAcceptCookies = () => {
    Cookies.set("cookieConsent", "true", {
      expires: 365,
      secure: true,
      sameSite: "Strict",
    })

    setCookieAccepted(true)

    // Inicializace GA až po souhlasu
    ReactGA.initialize(trackingID)
    ReactGA.set({ page: window.location.pathname })
    ReactGA.pageview(window.location.pathname)

    setTimeout(() => {
      setShowBanner(false)
    }, 3000)
  }

  const handleRemoveCookies = () => {
    Cookies.remove("cookieConsent")
    setCookieAccepted(true)
    setShowBanner(false)
  } 

  if (!showBanner) return null

  return (
    <section>
      {!cookieAccepted && (
        <div className="cookies-eu-banner">
          <p>
            Používáme cookies pro zlepšení vaší zkušenosti na našich stránkách.
            Pokud souhlasíte s jejich používáním, klikněte na tlačítko níže.
          </p>
          <Link to="/cookiePage">Více informací</Link>
          <button type="button" onClick={handleAcceptCookies}>Souhlasím</button>
          <button type="button" onClick={handleRemoveCookies()}>Odmítnout</button>
        </div>
      )}
    </section>
  )
}

export default CookiesConsent